import { Paper, PaperProps, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useCalculatedAdaptionIndVals } from "hooks/studyAreaHooks";

import { AdaptdationIndicator, StudyArea } from "types/types";

import DetailItem from "./DetailItem";
import { sortBy } from "lodash-es";
import { area } from "@turf/turf";
import { getGeojsonFeature } from "utils/GeomanUtils";

interface Props extends PaperProps {
  adaptationIndicatorValues: AdaptdationIndicator[];
  studyArea: StudyArea;
}

export function Details(props: Props) {
  const { adaptationIndicatorValues, studyArea, ...paperProps } = props;
  const { t } = useTranslation();

  const mappedIndicatorValues = useCalculatedAdaptionIndVals(
    adaptationIndicatorValues
  );
  const studyAreaFeature = getGeojsonFeature(studyArea.geometry_4326);

  return (
    <StyledPaper {...paperProps}>
      <Typography variant="h2" component="h2">
        {t("label.studyAreaInDetail")}
      </Typography>
      <Paper elevation={0} className="detail-section">
        <DetailItem
          mappedAdaptationIndicatorValue={{
            name: t("label.areaStudyArea"),
            description: "",
            value: area(studyAreaFeature),
            difference: 0,
            unit: "㎡",
          }}
        />
        {sortBy(mappedIndicatorValues, "name").map((adaptationValue, i) => (
          <DetailItem
            mappedAdaptationIndicatorValue={adaptationValue}
            key={`${adaptationValue.name}-${i}`}
          />
        ))}
      </Paper>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  .detail-section {
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing(2)};
    background-color: transparent;
    flex-wrap: wrap;
  }
`;
